import { DefaultFooter } from '@ant-design/pro-components';
import React from 'react';

const Footer: React.FC = () => {
  return (
    <DefaultFooter
      style={{
        background: 'none',
      }}
      copyright="Power by 株式会社 way pacific"
      links={[
        {
          key: 'ARC PRIME',
          title: 'ARC PRIME',
          href: 'https://www.arcprime.com',
          blankTarget: true,
        },
      ]}
    />
  );
};

export default Footer;
